<template>
  <div id="page-provide-number-per-rolls-edit">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between">
      <div>
        <h5>
          {{ $t('pages.qtyRolls.editQtyRoll') }}
          <strong>{{ ProvideNumberPerRollsModule.provideNumberPerRolls.name }}</strong>
        </h5>
      </div>
      <div>
        <router-link
            class="btn btn-outline-primary mb-3"
            :to="{ name: 'provide-number-per-rolls-index' }"
        >
          {{ $t('common.back') }}
        </router-link>
      </div>
    </div>

    {{ /* Form component */ }}
    <FormCrudProvideNumberPerRolls
        :provide-number-per-rolls="ProvideNumberPerRollsModule.provideNumberPerRolls"
        :id="ProvideNumberPerRollsModule.provideNumberPerRolls.id"
        :actionForm="'edit'"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      }
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
  },
  created() {
    this.showLoader()

    this.$store.dispatch('fetchProvideNumberPerRolls', this.$route.params.id)
  },
  updated() {
    this.hideLoader()
  },
  computed: {
    ...mapState(['ProvideNumberPerRollsModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    FormCrudProvideNumberPerRolls: () => import('@/components/pages/provideNumberPerRolls/FormCrudProvideNumberPerRolls')
  }
}
</script>

<style scoped>

</style>
